// generated by srcset-codegen
import src from "./sliders-horizontal.svg";

const width = 14;
const height = 14;
export default { src, width, height };
